import { createAsyncThunk } from '@reduxjs/toolkit';
import type {
  RecipientFilters,
  ComprovanteUpload,
  NegociacaoRequest,
} from '../../types/recipient.types';
import {
  setNotificacoes,
  appendNotificacoes,
  setNotificacaoAtual,
  setLoading,
  setError,
  setPagination,
  markAsRead,
  setComprovanteEnviado,
  setNegociacaoAberta,
} from './recipientSlice';
import * as recipientService from '../services/recipient.service';

export const fetchNotificacoesRecebidas = createAsyncThunk(
  'recipient/fetchNotificacoesRecebidas',
  async (filters: RecipientFilters, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      dispatch(setError(null));

      const response = await recipientService.getNotificacoesRecebidas(filters);

      if (filters.page === 1) {
        dispatch(setNotificacoes(response.data));
      } else {
        dispatch(appendNotificacoes(response.data));
      }

      dispatch(
        setPagination({
          page: response.page,
          total: response.total,
          limit: response.limit,
          hasMore: response.page * response.limit < response.total,
        }),
      );

      return response;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Erro ao carregar notificações';
      dispatch(setError(errorMessage));
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  },
);

export const fetchNotificacaoDetail = createAsyncThunk(
  'recipient/fetchNotificacaoDetail',
  async (id: string, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      dispatch(setError(null));

      const notificacao = await recipientService.getNotificacaoDetail(id);

      dispatch(setNotificacaoAtual(notificacao));

      if (!notificacao.foiLida) {
        await recipientService.marcarComoLida(id);
        dispatch(markAsRead(id));
      }

      return notificacao;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Erro ao carregar detalhes';
      dispatch(setError(errorMessage));
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  },
);

export const uploadComprovante = createAsyncThunk(
  'recipient/uploadComprovante',
  async (data: ComprovanteUpload, { dispatch }) => {
    try {
      const result = await recipientService.enviarComprovante(data.notificacaoId, data);

      dispatch(setComprovanteEnviado(data.notificacaoId));

      return result;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Erro ao enviar comprovante';
      throw new Error(errorMessage);
    }
  },
);

export const requestNegociacao = createAsyncThunk(
  'recipient/requestNegociacao',
  async (data: NegociacaoRequest, { dispatch }) => {
    try {
      const result = await recipientService.solicitarNegociacao(data.notificacaoId, data);

      dispatch(setNegociacaoAberta(data.notificacaoId));

      return result;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Erro ao solicitar negociação';
      throw new Error(errorMessage);
    }
  },
);
